import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { _ } from '../../functions/translator';
import moment from 'moment';
import { setSelectedWhatsAppObservations, setWhatsAppObservationsPopup } from '../../actions/index';
import Button from '@material-ui/core/Button';
import Icon from '@mdi/react';
import { mdiClose, mdiCheckCircle, mdiAlertCircle, mdiCalendarClock, mdiAccount, mdiMapMarker, mdiImage, mdiChevronDown, mdiChevronUp } from '@mdi/js';
import { whatsAppObservationFiltersPass } from '../../functions/cardsGroupsFeatures';

class WhatsAppObservationsList extends React.Component {
    
    constructor(props) {
        super(props)
        this.state = {
            topPosition: null,
            hoveredImageObservation: null,
            expandedExtraFields: {}, // Track which observations have expanded extra fields
        }
    }

    toggleExtraFields = (observationId) => {
        this.setState(prevState => ({
            expandedExtraFields: {
                ...prevState.expandedExtraFields,
                [observationId]: !prevState.expandedExtraFields[observationId]
            }
        }));
    }

    componentDidMount() {
        setTimeout(() => {
            if (this.list) {
                this.list.classList.add('whatsapp-observations-popup-menu-list-position')
            }
        }, 1);
    }

    componentDidUpdate() {
        if (this.props.popup !== 'none') {
            if (this.list) {
                this.list.style.opacity = 0
                this.list.style.pointerEvents = 'none'
            }
        } else {
            if (this.list) {
                this.list.style.opacity = 1
                this.list.style.pointerEvents = 'auto'
            }
        }

        if (this.props.whatsappObservationsPopup.expanded) {
            if (this.list) {
                this.list.classList.add('popup-list-expanded')
            }
        } else if (this.list && this.list.classList.contains('popup-list-expanded')) {
            this.list.classList.remove('popup-list-expanded')
            if (this.list) {
                this.list.style.top = '-215px'
            }
        }
    }

    formatDate(dateString) {
        if (!dateString) return '-';
        return moment(dateString).format('DD/MM/YYYY HH:mm');
    }

    removeObservation = (observationId) => {
        let filteredObservationIds = []
        this.props.selectedWhatsAppObservations.forEach(selectedObservationId => {
            if (selectedObservationId !== observationId) {
                filteredObservationIds.push(selectedObservationId)
            }
        })
        
        // Si no quedan observaciones, cerrar el popup inmediatamente
        if (filteredObservationIds.length === 0) {
            this.props.setWhatsAppObservationsPopup({ 
                show: false, 
                close: false, 
                closeList: false,
                expanded: false,
                opacity: 1 
            })
        }
        
        this.props.setSelectedWhatsAppObservations(filteredObservationIds)
    }


    getObservationData(observation) {
        const observationData = this.props.whatsappObservations.observations[String(observation.id)];
        if (!observationData || !observationData.observation) return null;
        return observationData.observation;
    }

    getObservedBy(observationDetails) {
        if (!observationDetails) return '-';
        const firstName = observationDetails.user_first_name || '';
        const lastName = observationDetails.user_last_name || '';
        const phone = observationDetails.user_phone || '';
        
        if (firstName || lastName) {
            return `${firstName} ${lastName}`.trim();
        }
        return phone || '-';
    }

    getResolvedStatus(observationDetails) {
        if (!observationDetails) return '-';
        return observationDetails.resolved ? _('Resuelta') : _('Sin Resolver');
    }

    getResolvedByInfo(observationDetails) {
        if (!observationDetails) return null;
        if (!observationDetails.resolved) return null;
        return observationDetails.resolved_by_display || null;
    }


    getObservationImages(observationId) {
        const observationData = this.props.whatsappObservations.observations[String(observationId)];
        if (!observationData || !observationData.observation) return [];
        
        const images = [];
        const messages = observationData.observation.whatsappmessages || [];
        const s3ImagesPath = this.props.whatsappObservations.s3_images_path || '';
        
        // Get images from whatsapp messages
        messages.forEach(message => {
            if (message && message.image_path) {
                images.push(`${s3ImagesPath}/${message.image_path}`);
            }
        });
        
        // Get resolution image if exists
        const resolutionDict = observationData.observation.resolution_message_dict;
        if (resolutionDict && resolutionDict.image) {
            images.push(resolutionDict.image);
        }
        
        return images;
    }

    render() {
        const { observations, whatsappFilters } = this.props;

        if (this.props.whatsappObservationsPopup.closeList && this.list) {
            this.list.classList.add('popup-menu-close-list')
        }

        // Apply filters to observations
        // const filteredObservations = observations.filter(observation => {
        //     const observationData = this.props.whatsappObservations.observations[String(observation.id)];
        //     return whatsAppObservationFiltersPass(whatsappFilters, observationData);
        // });

        const observationsRender = observations.map((observation, index) => {
            const observationDetails = this.getObservationData(observation);
            const observedBy = this.getObservedBy(observationDetails);
            const resolvedStatus = this.getResolvedStatus(observationDetails);
            const resolvedBy = this.getResolvedByInfo(observationDetails);
            const observationDate = observationDetails?.datetime ? this.formatDate(observationDetails.datetime) : '-';
            const rawMessage = observationDetails?.raw_message || '-';
            const extraFields = observationDetails?.extra_fields || {};
            const isResolved = observationDetails?.resolved;
            const images = this.getObservationImages(observation.id);
            const hasImages = images.length > 0;

            return (
                <div 
                    key={observation.id || index}
                    style={{
                        backgroundColor: '#252525',
                        borderRadius: '10px',
                        padding: '0',
                        marginBottom: '10px',
                        border: `2px solid ${isResolved ? '#59a14f' : '#e15759'}`,
                        position: 'relative',
                        transition: 'all 0.2s ease',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                        overflow: 'hidden'
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#2d2d2d';
                        e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.4)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#252525';
                        e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.3)';
                    }}
                >
                    {/* HEADER SECTION - Estado y ID */}
                    <div style={{
                        backgroundColor: isResolved ? 'rgba(89, 161, 79, 0.12)' : 'rgba(225, 87, 89, 0.12)',
                        padding: '8px 12px',
                        borderBottom: `1px solid ${isResolved ? 'rgba(89, 161, 79, 0.25)' : 'rgba(225, 87, 89, 0.25)'}`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: '10px'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            {/* ID Badge */}
                            <span style={{
                                fontSize: '14px',
                                fontWeight: '700',
                                color: '#fff',
                                backgroundColor: 'rgba(255,255,255,0.1)',
                                padding: '4px 10px',
                                borderRadius: '6px',
                                letterSpacing: '0.5px'
                            }}>
                                #{observation.id}
                            </span>
                            
                            {/* Status Badge */}
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                padding: '4px 12px',
                                borderRadius: '20px',
                                backgroundColor: isResolved ? '#59a14f' : '#e15759',
                                fontSize: '12px',
                                fontWeight: '600',
                                color: '#fff',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.2)'
                            }}>
                                <Icon 
                                    path={isResolved ? mdiCheckCircle : mdiAlertCircle} 
                                    size='14px' 
                                    color='#fff'
                                />
                                <span>{resolvedStatus}</span>
                            </div>

                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            {/* Images Icon with Counter */}
                            {hasImages && (
                                <div
                                    style={{
                                        position: 'relative',
                                        minWidth: '32px',
                                        height: '32px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderRadius: '8px',
                                        backgroundColor: 'rgba(37, 211, 102, 0.2)',
                                        cursor: 'pointer',
                                        border: '1px solid #25D366'
                                    }}
                                    onMouseEnter={() => this.setState({ hoveredImageObservation: observation.id })}
                                    onMouseLeave={() => this.setState({ hoveredImageObservation: null })}
                                >
                                    <Icon path={mdiImage} size='18px' color='#25D366'/>
                                    <span style={{
                                        position: 'absolute',
                                        top: '-6px',
                                        right: '-6px',
                                        backgroundColor: '#25D366',
                                        color: '#fff',
                                        fontSize: '9px',
                                        fontWeight: '700',
                                        padding: '2px 5px',
                                        borderRadius: '10px',
                                        minWidth: '18px',
                                        textAlign: 'center'
                                    }}>
                                        {images.length}
                                    </span>
                                    
                                    {/* Images Popup on Hover */}
                                    {this.state.hoveredImageObservation === observation.id && (
                                        <div style={{
                                            position: 'absolute',
                                            top: '40px',
                                            right: '0',
                                            backgroundColor: '#1a1a1a',
                                            border: '2px solid #25D366',
                                            borderRadius: '8px',
                                            padding: '12px',
                                            boxShadow: '0 8px 24px rgba(0,0,0,0.6)',
                                            zIndex: 1000,
                                            minWidth: '220px',
                                            maxWidth: '420px',
                                        }}>
                                            <div style={{
                                                fontSize: '12px',
                                                color: '#25D366',
                                                marginBottom: '10px',
                                                fontWeight: '700',
                                                textTransform: 'uppercase',
                                                letterSpacing: '0.5px'
                                            }}>
                                                {_('Imágenes')} ({images.length})
                                            </div>
                                            <div style={{
                                                display: 'grid',
                                                gridTemplateColumns: 'repeat(auto-fill, minmax(90px, 1fr))',
                                                gap: '8px',
                                                maxHeight: '320px',
                                                overflowY: 'auto'
                                            }}>
                                                {images.map((imageSrc, imgIndex) => (
                                                    <div key={imgIndex} style={{
                                                        width: '100%',
                                                        paddingBottom: '100%',
                                                        position: 'relative',
                                                        borderRadius: '6px',
                                                        overflow: 'hidden',
                                                        border: '2px solid #333',
                                                        cursor: 'pointer',
                                                        transition: 'all 0.2s ease'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.borderColor = '#25D366';
                                                        e.currentTarget.style.transform = 'scale(1.05)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.borderColor = '#333';
                                                        e.currentTarget.style.transform = 'scale(1)';
                                                    }}>
                                                        <img 
                                                            src={imageSrc} 
                                                            alt={`Imagen ${imgIndex + 1}`}
                                                            style={{
                                                                position: 'absolute',
                                                                top: 0,
                                                                left: 0,
                                                                width: '100%',
                                                                height: '100%',
                                                                objectFit: 'cover'
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                window.open(imageSrc, '_blank');
                                                            }}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* Close Button */}
                            <Button
                                size="small"
                                onClick={() => {this.removeObservation(String(observation.id))}}
                                style={{
                                    minWidth: '32px',
                                    width: '32px',
                                    height: '32px',
                                    padding: '0',
                                    borderRadius: '8px',
                                    backgroundColor: 'rgba(255,255,255,0.1)',
                                    transition: 'all 0.2s ease'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = 'rgba(231, 76, 60, 0.3)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.1)';
                                }}>
                                <Icon path={mdiClose} size='18px' color='#fff'/>
                            </Button>
                        </div>
                    </div>

                    {/* MAIN CONTENT SECTION */}
                    <div style={{ padding: '12px' }}>
                        {/* Mensaje Principal */}
                        <div style={{
                            fontSize: '14px',
                            color: '#f0f0f0',
                            lineHeight: '1.5',
                            marginBottom: '10px',
                            padding: '8px 10px',
                            backgroundColor: 'rgba(255,255,255,0.05)',
                            borderRadius: '6px',
                            borderLeft: '3px solid rgba(255,255,255,0.2)',
                            fontWeight: '400'
                        }}>
                            {rawMessage}
                        </div>

                        {/* METADATA SECTION - Horizontal compact layout */}
                        <div style={{ 
                            display: 'flex',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            gap: '6px',
                            marginBottom: '0'
                        }}>
                            {/* Date */}
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px',
                                backgroundColor: 'rgba(52, 152, 219, 0.15)',
                                padding: '4px 8px',
                                borderRadius: '6px',
                                fontSize: '12px',
                                color: '#5dade2'
                            }}>
                                <Icon path={mdiCalendarClock} size='14px' color='#5dade2'/>
                                <span style={{ fontWeight: '500' }}>{observationDate}</span>
                            </div>

                            {/* Observer */}
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px',
                                backgroundColor: 'rgba(155, 89, 182, 0.15)',
                                padding: '4px 8px',
                                borderRadius: '6px',
                                fontSize: '12px',
                                color: '#bb8fce'
                            }}>
                                <Icon path={mdiAccount} size='14px' color='#bb8fce'/>
                                <span style={{ fontWeight: '500' }}>{observedBy}</span>
                            </div>

                            {/* Resolved by */}
                            {resolvedBy && (
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '4px',
                                    backgroundColor: 'rgba(89, 161, 79, 0.2)',
                                    padding: '4px 8px',
                                    borderRadius: '6px',
                                    fontSize: '12px',
                                    color: '#59a14f',
                                    fontWeight: '600'
                                }}>
                                    <Icon path={mdiCheckCircle} size='14px' color='#59a14f'/>
                                    <span>{_('Resuelto por')}: {resolvedBy}</span>
                                </div>
                            )}
                        </div>


                        {/* Extra Fields - Collapsible */}
                        {extraFields && Object.keys(extraFields).length > 0 && (
                            <div style={{ marginTop: '8px' }}>
                                {/* Toggle Button */}
                                <div
                                    onClick={() => this.toggleExtraFields(observation.id)}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        padding: '6px 10px',
                                        backgroundColor: 'rgba(255,255,255,0.05)',
                                        borderRadius: '6px',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                        border: '1px solid rgba(255,255,255,0.1)',
                                        userSelect: 'none'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.08)';
                                        e.currentTarget.style.borderColor = 'rgba(255,255,255,0.2)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.05)';
                                        e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)';
                                    }}
                                >
                                    <span style={{
                                        fontSize: '12px',
                                        color: '#aaa',
                                        fontWeight: '600',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px'
                                    }}>
                                        {_('Campos Adicionales')} ({Object.keys(extraFields).length})
                                    </span>
                                    <Icon 
                                        path={this.state.expandedExtraFields[observation.id] ? mdiChevronUp : mdiChevronDown}
                                        size='18px'
                                        color='#aaa'
                                    />
                                </div>

                                {/* Collapsible Content */}
                                {this.state.expandedExtraFields[observation.id] && (
                                    <div style={{ 
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '3px',
                                        padding: '8px 10px',
                                        backgroundColor: 'rgba(255,255,255,0.03)',
                                        borderRadius: '6px',
                                        fontSize: '12px',
                                        marginTop: '4px',
                                        borderLeft: '3px solid rgba(255,255,255,0.1)',
                                        animation: 'fadeIn 0.2s ease'
                                    }}>
                                        {Object.entries(extraFields).map(([key, value]) => (
                                            <div key={key} style={{
                                                display: 'flex',
                                                gap: '8px',
                                                padding: '3px 0'
                                            }}>
                                                <span style={{ 
                                                    color: '#888',
                                                    minWidth: '120px',
                                                    fontWeight: '600'
                                                }}>{key}:</span>
                                                <span style={{ 
                                                    color: '#ddd',
                                                    flex: 1
                                                }}>{value}</span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            );
        });

        return (
            <div className={'popup-menu-list-layout card-transparent'} ref={ref => this.list = ref}>
                <div className="popup-menu-card-section card-color rounded-border mx-3 mb-3">
                    <div style={{ 
                        paddingRight: '6px'
                    }}>
                        {observationsRender}
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        popup: state.popup,
        whatsappObservationsPopup: state.whatsappObservations.popup,
        selectedWhatsAppObservations: state.whatsappObservations.selectedObservations,
        whatsappObservations: state.whatsappObservations,
        whatsappFilters: state.whatsappObservations.filters,
        projectData: state.projectData,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setSelectedWhatsAppObservations,
        setWhatsAppObservationsPopup,
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(WhatsAppObservationsList);

